module.exports = __webpack_public_path__ + "src/assets/images/action.7986b3ef5001a7f8618e2014e559e2d7.png";